import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getUser, logout } from '../redux/userActions'
import './Header.css'
import image from '../images/rxjs.gif'

import { Dropdown, Container, Button, Menu, Image } from 'semantic-ui-react'

// const LOGIN_PATH = '/login'
// const MAIN_PATH = '/'
const LOGIN_PATH = '/inCyberNotes/login'
const MAIN_PATH = '/inCyberNotes'

export class Header extends Component {
  state = {
    gitHub: false
  }

  enableGitHubIcon = () => {
    if (this.state.gitHub === false) {
      this.setState(() => ({
        gitHub: true
      }))
    }
  }

  logout = () => {
    this.props.logout()
    this.props.history.push(LOGIN_PATH)
  }

  onGitHub = () => {
    window.open('http://www.github.com/inPhoenix/', '_blank')
  }

  render() {
    return (
      <Menu fixed="top" inverted className="cyberHeader">
        {this.state.gitHub && (
          <Button.Group floated="left">
            <div className="ui vertical animated button secondary" tabIndex="0">
              <div className="hidden content" onClick={this.onGitHub}>
                gitHub
              </div>
              <div
                className="visible content"
                style={{ paddingBottom: '15px' }}
              >
                <i className="github large icon" />
              </div>
            </div>
          </Button.Group>
        )}

        <Container>
          <Menu.Item
            as="a"
            header
            onClick={() => this.props.history.push(MAIN_PATH)}
          >
            <Image size="mini" src={image} style={{ marginRight: '1.5em' }} />{' '}
            inCyberNotes
          </Menu.Item>`
          <Dropdown item simple text="Menu">
            <Dropdown.Menu>
              <Dropdown.Item onClick={this.logout}>Logout</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => this.props.history.push(MAIN_PATH)}>
                Home
              </Dropdown.Item>
              <Dropdown.Item onMouseOver={this.enableGitHubIcon}>
                <i className="dropdown icon" />
                <span className="text">External Links</span>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={this.onGitHub}>
                    inPhoenix GitHub
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Container>
        <Button.Group floated="left">
          <div className="ui vertical animated button secondary" tabIndex="0" style={{ backgroundColor: 'transparent' }}>
            <div className="hidden content" onClick={this.logout}>
              Sign Out
            </div>
            <div className="visible content" style={{ paddingBottom: '15px' }}>
              <i className="sign out alternate large icon" />
            </div>
          </div>
        </Button.Group>
      </Menu>
    )
  }
}

function mapState(state, ownProps) {
  return {
    user: state.user
  }
}

export default withRouter(connect(mapState, { getUser, logout })(Header))




// WEBPACK FOOTER //
// ./src/components/Header.js